import { render, staticRenderFns } from "./TournamentBackground.vue?vue&type=template&id=5d83530a&"
import script from "./TournamentBackground.vue?vue&type=script&lang=ts&"
export * from "./TournamentBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VParallax})
